import Endpoint from "../Endpoint";

class Auth extends Endpoint {
    baseUrl() {
        return process.env.VUE_APP_BASE_URL;
    }

    buildUrl() {
        return [];
    }

    login(form) {
        return this.request({
            url: '/login',
            action: 'login',
            method: 'POST',
            data: form
        });
    }

    logout() {
        return this.request({
            url: '/api/logout',
            action: 'logout',
            method: 'GET'
        });
    }

    me() {
        return this.request({
            url: '/api/me',
            action: 'me',
            method: 'GET'
        });
    }
};

export default new Auth;